import { windowContext } from '.'
import firebase from './firebaseWeb'
const analytics = windowContext() && firebase.analytics()

export default analytics
